import { render } from "./TicketColumnSettingsModal.vue?vue&type=template&id=a35fa212&scoped=true"
import script from "./TicketColumnSettingsModal.vue?vue&type=script&lang=js"
export * from "./TicketColumnSettingsModal.vue?vue&type=script&lang=js"

import "./TicketColumnSettingsModal.vue?vue&type=style&index=0&id=a35fa212&scoped=true&lang=scss"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a35fa212"]])

export default __exports__